<template>
	<div class="fc-bet">
		<div class="title">{{title}}</div>
		<div class="time">
			{{time321}}秒
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-title',
		props: {
			time:{
				type:[Number,String],
				default:100
			},
			title:{
				type:String,
				default:""
			}
		},
		data() {
			return {
				timer:null,
				time321:null,
				
			}
		},
		mounted() {
			this.countdown()
		},
		methods: {
			closeReadList() {
				
				this.$emit('close-return',false); 
			    this.openUrl("/")
			},
			countdown(){
				var that = this;
				that.time321 = that.time
				that.timer = setInterval(function() {
					that.time321--
					if (that.time321 < 1) {
						clearInterval(that.timer)
						that.closeReadList()
					}else{
						 that.$emit('remain-time',that.time321); 
					}
				}, 1000)
			}
		},
		watch: {
			time(newValue, oldValue) {
				clearInterval(this.timer);
				this.countdown()
				
			}
		},
		beforeDestroy() {
			clearInterval(this.timer);
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	@l:#01A0A0;
	@L:@l;
	.step-row{
		height: 78px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.line{
		width: 16px;
		height: 7px;
		background-color: #D9D9D9;
		margin: 0 7px;
		&.on{
			width: 244px;
		}
	}
	.point{
		width: 48px;
		height: 48px;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		background: #ADADAD;
		border: 3px solid #C9C9C9;
		
		font-size: 29px;color: #fff;
		line-height: 42px;
		text-align: center;
		border-radius: 100px;
		&.on{
			background-color: @L;
			border-color: rgba(0,0,0,0);
		}
	}
	.point-text{
		display: none;
		font-size: 30px;
		color: #01A1A0;
			margin: 0 14px;
			&.on{
				display: block;
			}
	}
</style>
